export const trainingModules = [
  {
    id: 'TM001',
    title: 'Spotting Spear Phishing',
    category: 'Phishing Education',
    difficultyLevel: 'Intermediate',
    duration: '15 min',
    deliveryFormat: 'Video',
    description: 'Learn to identify targeted phishing attacks using real-world examples. Covers spear phishing, whaling, and business email compromise tactics.',
    linkedComplianceTopic: 'NIST CSF - PR.AT',
    complianceTags: ['NIST CSF', 'SOC 2'],
    status: 'Active',
    usageCount: 3,
    lastUsed: '2024-01-15',
    assignedCampaigns: ['TC002', 'TC004'],
    createdAt: '2023-06-01',
    thumbnail: 'phishing',
    language: 'en',
  },
  {
    id: 'TM001-ES',
    title: 'Identificación de Spear Phishing',
    category: 'Phishing Education',
    difficultyLevel: 'Intermediate',
    duration: '15 min',
    deliveryFormat: 'Video',
    description: 'Aprende a identificar ataques de phishing dirigidos usando ejemplos del mundo real. Cubre spear phishing, whaling y tácticas de compromiso de correo empresarial.',
    linkedComplianceTopic: 'NIST CSF - PR.AT',
    complianceTags: ['NIST CSF', 'SOC 2'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2024-01-15',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'phishing',
    language: 'es',
  },
  {
    id: 'TM002',
    title: 'Password Best Practices 2024',
    category: 'Authentication',
    difficultyLevel: 'Beginner',
    duration: '10 min',
    deliveryFormat: 'Interactive',
    description: 'Covers password hygiene, MFA setup, and password manager usage. Includes interactive exercises for creating strong credentials.',
    linkedComplianceTopic: 'ISO 27001 - A.9.4',
    complianceTags: ['ISO 27001', 'SOC 2'],
    status: 'Active',
    usageCount: 2,
    lastUsed: '2024-01-10',
    assignedCampaigns: ['TC004'],
    createdAt: '2023-06-15',
    thumbnail: 'password',
    language: 'en',
  },
  {
    id: 'TM002-ES',
    title: 'Mejores Prácticas de Contraseñas 2024',
    category: 'Authentication',
    difficultyLevel: 'Beginner',
    duration: '10 min',
    deliveryFormat: 'Interactive',
    description: 'Cubre higiene de contraseñas, configuración de MFA y uso de gestores de contraseñas. Incluye ejercicios interactivos para crear credenciales seguras.',
    linkedComplianceTopic: 'ISO 27001 - A.9.4',
    complianceTags: ['ISO 27001', 'SOC 2'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2024-01-10',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'password',
    language: 'es',
  },
  {
    id: 'TM003',
    title: 'Physical Security in the Office',
    category: 'Physical Security',
    difficultyLevel: 'Beginner',
    duration: '20 min',
    deliveryFormat: 'Video',
    description: 'Tailgating prevention, clean desk policies, badge access control, and visitor management. Essential for all office-based employees.',
    linkedComplianceTopic: 'ISO 27001 - A.11',
    complianceTags: ['ISO 27001'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2024-01-10',
    assignedCampaigns: ['TC004'],
    createdAt: '2023-07-01',
    thumbnail: 'physical',
    language: 'en',
  },
  {
    id: 'TM003-ES',
    title: 'Seguridad Física en la Oficina',
    category: 'Physical Security',
    difficultyLevel: 'Beginner',
    duration: '20 min',
    deliveryFormat: 'Video',
    description: 'Prevención de tailgating, políticas de escritorio limpio, control de acceso con credenciales y gestión de visitantes. Esencial para todos los empleados en oficina.',
    linkedComplianceTopic: 'ISO 27001 - A.11',
    complianceTags: ['ISO 27001'],
    status: 'Active',
    usageCount: 0,
    lastUsed: null,
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'physical',
    language: 'es',
  },
  {
    id: 'TM004',
    title: 'Handling Sensitive Data (PII)',
    category: 'Compliance Training',
    difficultyLevel: 'Advanced',
    duration: '25 min',
    deliveryFormat: 'Course',
    description: 'Comprehensive training on identifying, handling, and protecting personally identifiable information. Covers data classification and breach response.',
    linkedComplianceTopic: 'GDPR - Art. 5',
    complianceTags: ['GDPR', 'CCPA', 'ISO 27001'],
    status: 'Active',
    usageCount: 4,
    lastUsed: '2024-01-20',
    assignedCampaigns: ['TC001'],
    createdAt: '2023-05-01',
    thumbnail: 'compliance',
    language: 'en',
  },
  {
    id: 'TM004-ES',
    title: 'Manejo de Datos Sensibles (PII)',
    category: 'Compliance Training',
    difficultyLevel: 'Advanced',
    duration: '25 min',
    deliveryFormat: 'Course',
    description: 'Capacitación completa sobre identificación, manejo y protección de información de identificación personal. Cubre clasificación de datos y respuesta a brechas.',
    linkedComplianceTopic: 'GDPR - Art. 5',
    complianceTags: ['GDPR', 'CCPA', 'ISO 27001'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2024-01-20',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'compliance',
    language: 'es',
  },
  {
    id: 'TM005',
    title: 'Reporting Suspicious Activity',
    category: 'Phishing Education',
    difficultyLevel: 'Beginner',
    duration: '5 min',
    deliveryFormat: 'Micro-learning',
    description: 'Quick reference guide for reporting phishing attempts, suspicious emails, and security incidents. Includes the report phishing button walkthrough.',
    linkedComplianceTopic: 'NIST CSF - DE.CM',
    complianceTags: ['NIST CSF'],
    status: 'Active',
    usageCount: 5,
    lastUsed: '2024-01-22',
    assignedCampaigns: ['TC002', 'TC004'],
    createdAt: '2023-05-15',
    thumbnail: 'report',
    language: 'en',
  },
  {
    id: 'TM005-ES',
    title: 'Reporte de Actividad Sospechosa',
    category: 'Phishing Education',
    difficultyLevel: 'Beginner',
    duration: '5 min',
    deliveryFormat: 'Micro-learning',
    description: 'Guía de referencia rápida para reportar intentos de phishing, correos sospechosos e incidentes de seguridad. Incluye guía del botón de reporte de phishing.',
    linkedComplianceTopic: 'NIST CSF - DE.CM',
    complianceTags: ['NIST CSF'],
    status: 'Active',
    usageCount: 2,
    lastUsed: '2024-01-22',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'report',
    language: 'es',
  },
  {
    id: 'TM006',
    title: 'Secure Remote Work Essentials',
    category: 'Policy Acknowledgement',
    difficultyLevel: 'Intermediate',
    duration: '30 min',
    deliveryFormat: 'Course',
    description: 'VPN usage, home network security, secure video conferencing, and remote work policy acknowledgement. Includes policy sign-off.',
    linkedComplianceTopic: 'SOC 2 - CC6.7',
    complianceTags: ['SOC 2', 'ISO 27001'],
    status: 'Active',
    usageCount: 2,
    lastUsed: '2024-01-05',
    assignedCampaigns: ['TC003'],
    createdAt: '2023-08-01',
    thumbnail: 'remote',
    language: 'en',
  },
  {
    id: 'TM006-ES',
    title: 'Esenciales del Trabajo Remoto Seguro',
    category: 'Policy Acknowledgement',
    difficultyLevel: 'Intermediate',
    duration: '30 min',
    deliveryFormat: 'Course',
    description: 'Uso de VPN, seguridad de red doméstica, videoconferencias seguras y reconocimiento de política de trabajo remoto. Incluye firma de política.',
    linkedComplianceTopic: 'SOC 2 - CC6.7',
    complianceTags: ['SOC 2', 'ISO 27001'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2024-01-05',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'remote',
    language: 'es',
  },
  {
    id: 'TM007',
    title: 'Social Engineering Awareness',
    category: 'Phishing Education',
    difficultyLevel: 'Advanced',
    duration: '20 min',
    deliveryFormat: 'Interactive',
    description: 'Advanced module covering vishing, smishing, pretexting, and in-person social engineering. Includes scenario-based decision trees.',
    linkedComplianceTopic: 'NIST CSF - PR.AT',
    complianceTags: ['NIST CSF', 'SOC 2'],
    status: 'Draft',
    usageCount: 0,
    lastUsed: null,
    assignedCampaigns: [],
    createdAt: '2023-11-01',
    thumbnail: 'social',
    language: 'en',
  },
  {
    id: 'TM007-ES',
    title: 'Concienciación sobre Ingeniería Social',
    category: 'Phishing Education',
    difficultyLevel: 'Advanced',
    duration: '20 min',
    deliveryFormat: 'Interactive',
    description: 'Módulo avanzado que cubre vishing, smishing, pretexting e ingeniería social presencial. Incluye árboles de decisión basados en escenarios.',
    linkedComplianceTopic: 'NIST CSF - PR.AT',
    complianceTags: ['NIST CSF', 'SOC 2'],
    status: 'Draft',
    usageCount: 0,
    lastUsed: null,
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'social',
    language: 'es',
  },
  {
    id: 'TM008',
    title: 'HIPAA Fundamentals for Staff',
    category: 'Compliance Training',
    difficultyLevel: 'Intermediate',
    duration: '45 min',
    deliveryFormat: 'Course',
    description: 'Complete HIPAA training covering PHI, minimum necessary standard, breach notification, and patient rights. Required for healthcare-adjacent roles.',
    linkedComplianceTopic: 'HIPAA - 45 CFR §164',
    complianceTags: ['HIPAA'],
    status: 'Active',
    usageCount: 2,
    lastUsed: '2023-09-30',
    assignedCampaigns: ['TC005'],
    createdAt: '2023-04-01',
    thumbnail: 'hipaa',
    language: 'en',
  },
  {
    id: 'TM009',
    title: 'Acceptable Use Policy Quiz',
    category: 'Policy Acknowledgement',
    difficultyLevel: 'Beginner',
    duration: '8 min',
    deliveryFormat: 'Quiz',
    description: '10-question quiz validating understanding of the company acceptable use policy. Employees must score 80%+ to pass. Includes policy acknowledgement sign-off.',
    linkedComplianceTopic: 'ISO 27001 - A.6.2',
    complianceTags: ['ISO 27001', 'SOC 2'],
    status: 'Active',
    usageCount: 6,
    lastUsed: '2024-01-22',
    assignedCampaigns: ['TC001', 'TC003'],
    createdAt: '2023-03-15',
    thumbnail: 'quiz',
    language: 'en',
  },
  {
    id: 'TM009-ES',
    title: 'Cuestionario de Política de Uso Aceptable',
    category: 'Policy Acknowledgement',
    difficultyLevel: 'Beginner',
    duration: '8 min',
    deliveryFormat: 'Quiz',
    description: 'Cuestionario de 10 preguntas para validar la comprensión de la política de uso aceptable. Los empleados deben obtener 80%+ para aprobar. Incluye firma de reconocimiento.',
    linkedComplianceTopic: 'ISO 27001 - A.6.2',
    complianceTags: ['ISO 27001', 'SOC 2'],
    status: 'Active',
    usageCount: 2,
    lastUsed: '2024-01-22',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'quiz',
    language: 'es',
  },
  {
    id: 'TM010',
    title: 'Phishing Simulation Debrief',
    category: 'Phishing Education',
    difficultyLevel: 'Beginner',
    duration: '7 min',
    deliveryFormat: 'Micro-learning',
    description: 'Post-simulation education module automatically assigned after a failed phishing test. Explains what clues were missed and how to spot them next time.',
    linkedComplianceTopic: 'NIST CSF - PR.AT',
    complianceTags: ['NIST CSF'],
    status: 'Active',
    usageCount: 8,
    lastUsed: '2024-01-20',
    assignedCampaigns: ['TC002'],
    createdAt: '2023-06-01',
    thumbnail: 'debrief',
    language: 'en',
  },
  {
    id: 'TM010-ES',
    title: 'Análisis de Simulación de Phishing',
    category: 'Phishing Education',
    difficultyLevel: 'Beginner',
    duration: '7 min',
    deliveryFormat: 'Micro-learning',
    description: 'Módulo educativo post-simulación asignado automáticamente tras fallar una prueba de phishing. Explica qué señales se omitieron y cómo detectarlas la próxima vez.',
    linkedComplianceTopic: 'NIST CSF - PR.AT',
    complianceTags: ['NIST CSF'],
    status: 'Active',
    usageCount: 3,
    lastUsed: '2024-01-20',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'debrief',
    language: 'es',
  },
  {
    id: 'TM011',
    title: 'GDPR Data Subject Rights',
    category: 'Compliance Training',
    difficultyLevel: 'Advanced',
    duration: '35 min',
    deliveryFormat: 'Course',
    description: 'Deep dive into GDPR Articles 15–22 covering data subject rights, request handling procedures, and documentation requirements for EU data processors.',
    linkedComplianceTopic: 'GDPR - Art. 15-22',
    complianceTags: ['GDPR'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2023-12-01',
    assignedCampaigns: [],
    createdAt: '2023-09-01',
    thumbnail: 'gdpr',
    language: 'en',
  },
  {
    id: 'TM011-ES',
    title: 'Derechos de los Titulares de Datos RGPD',
    category: 'Compliance Training',
    difficultyLevel: 'Advanced',
    duration: '35 min',
    deliveryFormat: 'Course',
    description: 'Análisis profundo de los Artículos 15–22 del RGPD sobre derechos de los titulares de datos, procedimientos de gestión de solicitudes y requisitos de documentación.',
    linkedComplianceTopic: 'GDPR - Art. 15-22',
    complianceTags: ['GDPR'],
    status: 'Active',
    usageCount: 0,
    lastUsed: null,
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'gdpr',
    language: 'es',
  },
  {
    id: 'TM012',
    title: 'Incident Response Basics',
    category: 'Policy Acknowledgement',
    difficultyLevel: 'Intermediate',
    duration: '18 min',
    deliveryFormat: 'Video',
    description: 'Step-by-step walkthrough of the company incident response plan. Covers detection, containment, eradication, and recovery phases with role-specific responsibilities.',
    linkedComplianceTopic: 'NIST CSF - RS.RP',
    complianceTags: ['NIST CSF', 'ISO 27001', 'SOC 2'],
    status: 'Active',
    usageCount: 3,
    lastUsed: '2024-01-18',
    assignedCampaigns: ['TC001'],
    createdAt: '2023-07-15',
    thumbnail: 'incident',
    language: 'en',
  },
  {
    id: 'TM012-ES',
    title: 'Fundamentos de Respuesta a Incidentes',
    category: 'Policy Acknowledgement',
    difficultyLevel: 'Intermediate',
    duration: '18 min',
    deliveryFormat: 'Video',
    description: 'Guía paso a paso del plan de respuesta a incidentes de la empresa. Cubre fases de detección, contención, erradicación y recuperación con responsabilidades por rol.',
    linkedComplianceTopic: 'NIST CSF - RS.RP',
    complianceTags: ['NIST CSF', 'ISO 27001', 'SOC 2'],
    status: 'Active',
    usageCount: 1,
    lastUsed: '2024-01-18',
    assignedCampaigns: [],
    createdAt: '2024-01-01',
    thumbnail: 'incident',
    language: 'es',
  },
];